var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M97.2058+815.651L97.2058+291.65L926.874+291.65L926.874+815.651C926.874+863.684+887.574+902.984+839.54+902.984L184.539+902.984C136.506+902.984+97.2058+863.684+97.2058+815.651Z",
    fill: "#fffde8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33a7ff",
    opacity: 1,
    d: "M926.541+216.373L926.541+344.268L96.8736+344.268L96.8736+216.373C96.8736+169.479+136.174+131.11+184.207+131.11L839.208+131.11C887.241+131.11+926.541+169.479+926.541+216.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.058+469.304L389.058+570.776C389.058+582.785+379.322+592.52+367.314+592.52L265.841+592.52C253.832+592.52+244.097+582.785+244.097+570.776L244.097+469.304C244.097+457.295+253.832+447.56+265.841+447.56L367.314+447.56C379.322+447.56+389.058+457.295+389.058+469.304Z",
    fill: "#d4d2ba",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.783+449.043L563.255+449.043C575.264+449.043+584.999+458.778+584.999+470.787L584.999+572.259C584.999+584.268+575.264+594.003+563.255+594.003L461.783+594.003C449.774+594.003+440.039+584.268+440.039+572.259L440.039+470.787C440.039+458.778+449.774+449.043+461.783+449.043Z",
    opacity: 1,
    fill: "#d4d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#d4d2ba",
    d: "M657.725+450.525L759.197+450.525C771.206+450.525+780.941+460.26+780.941+472.269L780.941+573.742C780.941+585.75+771.206+595.486+759.197+595.486L657.725+595.486C645.716+595.486+635.981+585.75+635.981+573.742L635.981+472.269C635.981+460.26+645.716+450.525+657.725+450.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#d4d2ba",
    d: "M265.841+643.806L367.314+643.806C379.322+643.806+389.058+653.541+389.058+665.55L389.058+767.022C389.058+779.031+379.322+788.766+367.314+788.766L265.841+788.766C253.832+788.766+244.097+779.031+244.097+767.022L244.097+665.55C244.097+653.541+253.832+643.806+265.841+643.806Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M461.783+640.841L563.255+640.841C575.264+640.841+584.999+650.576+584.999+662.585L584.999+764.057C584.999+776.066+575.264+785.801+563.255+785.801L461.783+785.801C449.774+785.801+440.039+776.066+440.039+764.057L440.039+662.585C440.039+650.576+449.774+640.841+461.783+640.841Z",
    fill: "#d4d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5245",
    d: "M657.725+642.323L759.197+642.323C771.206+642.323+780.941+652.058+780.941+664.067L780.941+765.539C780.941+777.548+771.206+787.283+759.197+787.283L657.725+787.283C645.716+787.283+635.981+777.548+635.981+765.539L635.981+664.067C635.981+652.058+645.716+642.323+657.725+642.323Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0212+308.223L926.689+308.223L926.689+344.035L97.0212+344.035L97.0212+308.223Z",
    fill: "#288aec",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.83+953.208L1236.09+953.208C1237.27+953.208+1238.22+954.161+1238.22+955.338L1238.22+955.338C1238.22+956.515+1237.27+957.469+1236.09+957.469L1231.83+957.469C1230.65+957.469+1229.7+956.515+1229.7+955.338L1229.7+955.338C1229.7+954.161+1230.65+953.208+1231.83+953.208Z",
    opacity: 1,
    fill: "#cd4238"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.51add4557720b18fd943e7e1cb4cf722.svg";
export { ForwardRef as ReactComponent };